import React from 'react';
import Markdown from '../markdown';
import styled from 'styled-components';

const NoteWrapper = styled.div`
  font-family: ${p => p.theme.serif};
  line-height: 1.5em;
  font-size: 16px;
  color: #454545;
  font-weight: 300;
  align-items: center;
  padding: 1em;
  margin: 1em;
  letter-spacing: 0.0125em;
  background: #f9f9f0;
  border: 1px solid #f3f3e9;
`;

const ChapterNote = ({ chapter }) => {
  let text = chapter.recap;
  return (
    <NoteWrapper>
      <Markdown text={text} />
    </NoteWrapper>
  );
};

export default ChapterNote;
